<div class="card modern-card wide-card d-flex flex-column">
  <!-- Header -->
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">
          Distributor Inventory Search
        </h1>
      </div>
      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="openAppDashboardClick()"
          title="Close"
          >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>

    <!-- Action Bar -->
    <div
      class="action-bar mt-3 d-flex align-items-center gap-3 bg-dark-subtle rounded-3 flex-wrap"
      >
      <!-- Browse Categories / Manufacturers -->
      <div class="browse-wrap d-flex align-items-center gap-2">
        <span
          class="browse-link text-muted"
          [class.active]="showBrowsePanel && browseTab === 'categories'"
          (click)="openBrowsePanel('categories')"
          >
          Categories
        </span>
        <span class="browse-divider text-muted">|</span>
        <span
          class="browse-link text-muted"
          [class.active]="showBrowsePanel && browseTab === 'manufacturers'"
          (click)="openBrowsePanel('manufacturers')"
          >
          Manufacturers
        </span>

        @if (showBrowsePanel) {
          <div class="browse-backdrop" (click)="closeBrowsePanel()"></div>
          <div class="browse-panel">
            <div class="browse-header">
              <span class="browse-header-title">
                @if (browseTab === 'categories') {
                  Categories
                } @else {
                  Manufacturers
                }
              </span>
            </div>

            @if (browseTab === 'categories') {
              <div class="browse-body">
                @if (categoriesList.length === 0) {
                  <div class="browse-empty">Loading categories...</div>
                } @else {
                  <div class="category-columns">
                    @for (category of categoriesList; track category) {
                      <div class="category-item" (click)="selectCategory(category)">
                        {{ category }}
                      </div>
                    }
                  </div>
                }
              </div>
            } @else {
              <div class="browse-body manufacturers-body">
                @if (manufacturersList.length === 0) {
                  <div class="browse-empty">Loading manufacturers...</div>
                } @else {
                  <div class="letter-index">
                    @for (group of manufacturersGrouped; track group.letter) {
                      <span class="letter-link" (click)="scrollToLetter(group.letter)">{{ group.letter }}</span>
                    }
                  </div>
                  <div class="manufacturer-groups">
                    @for (group of manufacturersGrouped; track group.letter) {
                      <div class="manufacturer-group" [id]="'mfg-letter-' + group.letter">
                        <div class="manufacturer-letter">{{ group.letter }}</div>
                        <div class="manufacturer-columns">
                          @for (mfg of group.items; track mfg) {
                            <div class="manufacturer-item" (click)="selectManufacturer(mfg)">
                              {{ mfg }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <!-- UPC Lookup -->
      <div class="d-flex align-items-center gap-2">
        <label class="action-label text-dark" for="item_upc">UPC:</label>
        <input
          class="form-control form-control-sm search-input"
          type="text"
          id="item_upc"
          placeholder="Scan or enter UPC..."
          [(ngModel)]="item_upc"
          (keyup.enter)="onItemUpcEnter($event)"
          />
        </div>

        <!-- Search Term -->
        <div class="d-flex align-items-center gap-2">
          <label class="action-label text-dark" for="search_term">Search:</label>
          <input
            class="form-control form-control-sm search-input"
            type="text"
            id="search_term"
            placeholder="Search by term..."
            [(ngModel)]="search_term"
            (keyup.enter)="onSearchTermEnter($event)"
            />
          </div>

          <!-- Search -->
          <button class="btn btn-sm red-btn" (click)="onSearchClick()">
            <i class="fa-solid fa-search me-2"></i>Search
          </button>
          <!-- My Favorites -->
          <button class="btn btn-sm grey-btn" (click)="onMyFavoritesClick()">
            <i class="fa-solid fa-star me-2" style="color: darkkhaki"></i>My Favorites
          </button>

          <div class="ms-auto d-flex gap-2">
            <button
              class="btn btn-sm grey-btn"
              (click)="clearTableClick()"
              [disabled]="sharedService.item_data?.length === 0"
              >
              <i class="fa-solid fa-eraser me-2"></i>Clear Table
            </button>
            <button class="btn btn-sm grey-btn" (click)="openRequestListsClick()">
              <i class="fa-solid fa-list me-2"></i>Request Lists
            </button>
          </div>
        </div>
      </div>

      <!-- Body: Filters + Grid + Vendor Sidebar -->
      <div class="card-body p-0 d-flex overflow-hidden position-relative" style="flex: 1; min-height: 0">
        <!-- Attribute Filters -->
        @if (activeBrowse) {
          @if (showFilterSidebar) {
            <div
              class="filter-sidebar"
              [class.dragging]="isDraggingFilter"
              [style.width.px]="filterSidebarWidth"
              [style.flex-basis.px]="filterSidebarWidth"
              (mousedown)="onFilterDragStart($event)"
              >
              <div class="filter-header">
                <div class="filter-title">
                  <span class="filter-title-text">Filter Your Results</span>
                  <button
                    type="button"
                    class="filter-collapse-btn"
                    (click)="toggleFilterSidebar()"
                    title="Collapse filters"
                    >
                    <i class="fa-solid fa-angles-left"></i>
                  </button>
                </div>
                <div class="filter-subtitle">
                  {{ activeBrowse.value }} &middot; {{ filteredItemCount }} of
                  {{ sharedService.item_data.length }}
                </div>
                @if (hasActiveFacets) {
                  <button
                    type="button"
                    class="filter-clear-all"
                    (click)="clearAllFacets()"
                    >
                    Clear all filters
                  </button>
                }
              </div>

              <div class="filter-scroll">
                @for (group of facetGroups; track group.key) {
                  <div class="facet-group">
                    <button
                      type="button"
                      class="facet-toggle"
                      (click)="toggleFacetCollapse(group.key)"
                      >
                      <i
                        class="fa-solid facet-caret"
                        [class.fa-caret-right]="group.collapsed"
                        [class.fa-caret-down]="!group.collapsed"
                      ></i>
                      <span class="facet-name">{{ group.label }}</span>
                      @if (group.selectedCount) {
                        <span class="facet-badge">{{ group.selectedCount }}</span>
                      } @else if (group.collapsed) {
                        <span class="facet-count">{{ group.options.length }}</span>
                      }
                    </button>

                    @if (!group.collapsed) {
                      <div class="facet-options">
                        @for (option of group.visibleOptions; track option.value) {
                          <label
                            class="facet-option"
                            [class.disabled]="option.count === 0 && !option.selected"
                            >
                            <input
                              type="checkbox"
                              [checked]="option.selected"
                              (change)="toggleFacetOption(group.key, option.value)"
                              />
                            <span class="facet-option-label">{{ option.label }}</span>
                            <span class="facet-option-count">({{ option.count }})</span>
                          </label>
                        }

                        @if (group.hiddenCount > 0) {
                          <button
                            type="button"
                            class="facet-more"
                            (click)="toggleFacetExpanded(group.key)"
                            >
                            Show {{ group.hiddenCount }} more
                          </button>
                        } @else if (group.expanded) {
                          <button
                            type="button"
                            class="facet-more"
                            (click)="toggleFacetExpanded(group.key)"
                            >
                            Show less
                          </button>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          } @else {
            <button
              type="button"
              class="filter-collapsed-tab"
              cdkDrag
              cdkDragLockAxis="y"
              (click)="toggleFilterSidebar()"
              title="Show filters (drag to move)"
              >
              <i class="fa-solid fa-filter"></i>
              @if (hasActiveFacets) {
                <span class="filter-expand-dot"></span>
              }
            </button>
          }
        }

        <!-- AG Grid + Footer -->
        <div class="d-flex flex-column" style="flex: 1; min-height: 0; overflow: hidden">
          <div style="flex: 1; overflow: hidden">
            <ag-grid-angular
              id="dispo_list"
                #dispo_list
              class="modern-grid"
              style="width: 100%; height: 100%"

              [columnDefs]="columnDefs"
              [gridOptions]="gridOptions"
              [defaultColDef]="defaultColDef"
              [rowData]="sharedService.item_data"
              [overlayLoadingTemplate]="overlayLoadingTemplate"
              [animateRows]="true"
              [rowSelection]="rowSelection"
              [components]="components"
              [isExternalFilterPresent]="isExternalFilterPresent"
              [doesExternalFilterPass]="doesExternalFilterPass"
              (gridReady)="onGridReady($event)"
              (rowClicked)="onRowClicked($event)"
              [preventDefaultOnContextMenu]="true"
              (cellContextMenu)="onCellContextMenu($event)"
              (filterChanged)="storeCurrentSessionFilters()"
              (columnPinned)="storeCurrentSessionColumnConfig()"
              (columnResized)="storeCurrentSessionColumnConfig()"
              (columnMoved)="storeCurrentSessionColumnConfig()"
              (sortChanged)="storeCurrentSessionColumnConfig()"
            ></ag-grid-angular>
          </div>

          <!-- Footer -->
          <div class="card-footer-bar d-flex align-items-center gap-3 px-4 py-2 flex-wrap">
            @if (lastSyncTime) {
              <span class="action-label footer-updated">
                Last Updated:
                <span class="fw-medium">{{ lastSyncTime | date: "short" }}</span>
              </span>
            }

            <div
              class="distributor-legend d-flex align-items-center gap-3"
              [class.border-start]="lastSyncTime"
              [class.ps-3]="lastSyncTime"
              >
              @for (dist of distributorList; track dist) {
                @if (dist.inventory && dist.dotClass && isDistributorActive(dist.name)) {
                  <div class="legend-item">
                    <i class="fa-solid fa-circle {{dist.dotClass}} small-dot"></i>
                    <span class="legend-text">{{ dist.label || dist.name }}</span>
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <!-- Vendor Panel Sidebar -->
        <div class="vendor-sidebar" (contextmenu)="$event.preventDefault()">
          @if (sharedService.item_data.length > 0) {
            <div class="vendor-sidebar-inner">
              <div class="vendor-panels-scroll">
                @if (distributorDisplayData.length !== 0) {
                  <div class="vendor-upc-badge">
                    <span class="upc-icon"><i class="fa-solid fa-barcode"></i></span>
                    <span class="upc-label">UPC</span>
                    <span class="upc-value">{{ selectedRow?.upc || item_upc }}</span>
                    <button class="upc-copy-btn" (click)="copyUpcBadge()" title="Copy UPC">
                      <i class="fa-regular fa-copy"></i>
                    </button>
                  </div>
                }

                @for (
                  distributor of distributorDisplayData;
                  track distributor;
                  let i = $index
                  ) {
                  <div
                    class="vendor-panel"
                [ngClass]="{
                  'best-in-stock': distributor.quantity > 0,
                  'no-stock': distributor.quantity === 0,
                }"
                    (contextmenu)="$event.preventDefault(); $event.stopPropagation(); onRightClick($event, distributor)"
                    >
                    <div class="vendor-panel-top">
                      <span class="vendor-name">{{
                        (distributor.name | replace: "_" : " ").toUpperCase()
                      }}</span>
                    </div>
                    <div class="vendor-meta">
                      <div class="stock-info">
                        <span
                          class="stock-pill"
                          [class.stock-positive]="distributor.quantity > 0"
                          >
                          <i class="fa-solid fa-circle stock-dot"></i>
                          {{ distributor.quantity > 0 ? "In stock" : "Out of stock" }}
                        </span>
                        <span
                          class="qty-pill"
                          [class.qty-positive]="distributor.quantity > 0"
                          >
                          {{ distributor.quantity }}
                        </span>
                      </div>
                      <span
                        class="price-badge"
                        [class.price-positive]="distributor.quantity > 0"
                        >{{
                        distributor.price ? "$" + distributor.price : "N/A"
                      }}</span>
                    </div>
                  </div>
                }
              </div>

              <div class="thumbnail-container fixed-bottom-thumbnail">
                @if (isThumbnailLoading) {
                  <div class="loading-thumbnail">
                    <i class="fa-solid fa-circle-notch fa-spin"></i>
                    <span>Fetching Image...</span>
                  </div>
                } @else if (itemThumbnailUrls.length > 0) {
                  <img
                    [src]="itemThumbnailUrls[currentImageIndex]"
                    alt="Item Thumbnail"
                    class="item-thumbnail"
                    (click)="toggleLightbox(true)"
                    title="Click to expand"
                    style="cursor: zoom-in"
                    />

                    <button
                      class="expand-btn"
                      (click)="toggleLightbox(true)"
                      title="Expand Image"
                      >
                      <i class="fa-solid fa-maximize"></i>
                    </button>

                    @if (itemThumbnailUrls.length > 1) {
                      <button
                        class="carousel-btn prev"
                        (click)="prevImage($event)"
                        title="Previous Image"
                        >
                        <i class="fa-solid fa-chevron-left"></i>
                      </button>
                      <button
                        class="carousel-btn next"
                        (click)="nextImage($event)"
                        title="Next Image"
                        >
                        <i class="fa-solid fa-chevron-right"></i>
                      </button>

                      <div class="carousel-count">
                        {{ currentImageIndex + 1 }} / {{ itemThumbnailUrls.length }}
                      </div>

                      <div class="carousel-indicators">
                        @for (img of itemThumbnailUrls; track img; let idx = $index) {
                          <div
                            class="indicator"
                            [class.active]="idx === currentImageIndex"
                          ></div>
                        }
                      </div>
                    }
                  } @else {
                    <div class="no-image-placeholder">
                      <i class="fa-solid fa-image-slash"></i>
                      <span>No Image Available</span>
                    </div>
                  }
                </div>

                <!-- Context Menu -->
                @if (showMenu) {
                  <div
                    class="context-menu"
                    [style.top.px]="menuTop"
                    [style.left.px]="menuLeft"
                    >
                    <div
                (click)="
                  menuAction('Get Pricing', item_upc || selectedRow?.upc)
                "
                      >
                      <i class="fa-solid fa-tag me-2"></i>Get Competitor Pricing
                    </div>
                    <div
                      (click)="menuAction('Copy UPC', item_upc || selectedRow?.upc)"
                      >
                      <i class="fa-solid fa-copy me-2"></i>Copy UPC
                    </div>
                    <div
                      (click)="menuAction('Copy Price', item_upc || selectedRow?.upc)"
                      >
                      <i class="fa-solid fa-dollar-sign me-2"></i>Copy Price
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Lightbox Overlay -->
      @if (isLightboxOpen && itemThumbnailUrls.length > 0) {
        <div class="lightbox-overlay" (click)="toggleLightbox(false)">
          <button class="close-lightbox" (click)="toggleLightbox(false)">
            <i class="fa-solid fa-xmark"></i>
          </button>

          @if (itemThumbnailUrls.length > 1) {
            <button class="lightbox-nav prev" (click)="prevImage($event)">
              <i class="fa-solid fa-chevron-left"></i>
            </button>
            <button class="lightbox-nav next" (click)="nextImage($event)">
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          }

          <div class="lightbox-content" (click)="$event.stopPropagation()">
            <img
              [src]="itemThumbnailUrls[currentImageIndex]"
              alt="Expanded Thumbnail"
              />

              @if (itemThumbnailUrls.length > 1) {
                <div
                  class="carousel-count"
          style="
            bottom: -30px;
            top: auto;
            right: 50%;
            transform: translateX(50%);
          "
                  >
                  {{ currentImageIndex + 1 }} / {{ itemThumbnailUrls.length }}
                </div>
              }
            </div>
          </div>
        }
        <!-- Added for the right click "Copy" function -->
        @if ((menuState$ | async)?.showMenu) {
          <div
            class="custom-context-menu"
            [style.top.px]="(menuState$ | async)?.menuTop"
            [style.left.px]="(menuState$ | async)?.menuLeft"
            (mouseenter)="onMenuMouseEnter()"
            (mouseleave)="onMenuMouseLeave()"
            >
            <div (click)="copyCellValue()">
              <i class="fa-solid fa-copy me-2"></i> Copy
            </div>
            <div (click)="addToWantsAlert()">
              <i class="fa-solid fa-bell me-2"></i> Add to Wants Alert
            </div>
            <div (click)="addToAutoPurchase()">
              <i class="fa-solid fa-cart-plus me-2"></i> Add to Auto-Purchase
            </div>
          </div>
        }
